module.exports = __webpack_public_path__ + "img/high-speed_driving_test.636152d8.jpg";